import { type FormEvent, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { Alert, Button, Field } from "@/components/ui";
import { authClient } from "@/lib/authClient";
import { errText, useT } from "@/lib/i18n";
import { AuthLayout } from "./AuthLayout";

export function Recover() {
  const t = useT();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    await authClient.requestPasswordReset({ email, redirectTo: "/restablecer" });
    setBusy(false);
    setDone(true);
  }
  return (
    <AuthLayout title={t.recover}>
      {done ? (
        <Alert kind="success">{t.recoverySent}</Alert>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field
            label={t.email}
            name="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" className="w-full" loading={busy}>
            {t.sendRecovery}
          </Button>
        </form>
      )}
      <Link to="/login" className="mt-5 inline-block text-sm text-muted hover:text-text">
        {t.back}
      </Link>
    </AuthLayout>
  );
}

export function ResetPassword() {
  const t = useT();
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const nav = useNavigate();
  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError(t.errors.PASSWORD_MISMATCH ?? t.error);
      return;
    }
    setBusy(true);
    const r = await authClient.resetPassword({ newPassword: password, token });
    setBusy(false);
    if (r.error) setError(errText(t, r.error.code));
    else {
      setDone(true);
      setTimeout(() => nav("/login"), 1500);
    }
  }
  return (
    <AuthLayout title={t.changePassword}>
      {done ? (
        <Alert kind="success">{t.passwordChanged}</Alert>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field
            label={t.newPassword}
            name="password"
            type="password"
            autoComplete="new-password"
            minLength={8}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Field
            label={t.confirmPassword}
            name="confirm"
            type="password"
            autoComplete="new-password"
            minLength={8}
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
          {error ? <Alert kind="error">{error}</Alert> : null}
          <Button type="submit" className="w-full" loading={busy}>
            {t.changePassword}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
